import { Button } from "@/design-system/components/ui/button";
import { Card, CardContent } from "@/design-system/components/ui/card";
import { FRONTEND_ROUTES } from "@fysaro/shared";
import { Construction, LogOut } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "@/app/store/auth.store";
import { supabase } from "@/shared/lib/supabase";

export function MaintenancePage() {
  const { t } = useTranslation(["auth"]);
  const logout = useAuthStore((s) => s.logout);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    logout();
    window.location.href = FRONTEND_ROUTES.auth.loginClinic;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/30 px-4">
      <Card className="w-full max-w-md shadow-lg border-primary/30 border-t-4 border-t-primary">
        <CardContent className="pt-10 pb-12 px-6 flex flex-col items-center text-center">
          <div className="p-4 rounded-full bg-primary/10 text-primary mb-6">
            <Construction className="h-12 w-12" />
          </div>

          <h1 className="text-2xl font-extrabold tracking-tight text-foreground sm:text-3xl mb-3">
            {t("auth:maintenance.title")}
          </h1>

          <p className="text-sm text-muted-foreground max-w-sm mb-8 leading-relaxed">
            {t("auth:maintenance.message")}
          </p>

          <Button
            variant="outline"
            onClick={handleLogout}
            className="gap-2 w-full sm:w-auto"
          >
            <LogOut className="h-4 w-4" />
            {t("auth:maintenance.logout")}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
